import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const SortDesc = createSvgIcon(
  <path d="M12 18 3 6h18l-9 12Z" />,
  'SortDesc'
);

export { SortDesc };
